var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointsBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFCC00;stroke-width:2.1747;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#EE0000;stroke-width:2.1747;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#EE0000;stroke-width:1.935;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#EE0000;stroke-width:2.1747;stroke-miterlimit:10;}\n\t.st4{fill:#FFCC00;stroke:#FFFFFF;stroke-width:1.0874;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9678 -0.2516 0.2516 0.9678 -7.1854 10.8676)",
    className: "st0",
    cx: 38.9,
    cy: 33.5,
    rx: 4.3,
    ry: 4.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.3,21.4l-9.5,2.5c-1.8,0.5-2.8,2.2-2.3,4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "55.3,20.9 53.6,14.5 46.1,16.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,39.5l2.2,8.4l-41,10.7c-1.8,0.5-3.5-0.6-4-2.3l-7.4-28.4c0.5,1.8,2.2,2.8,4,2.3l41-10.7l1.9,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.4,32.2c-3.2,0.8-4.6,3.7-3.9,6.6c0.8,2.9,3.4,4.7,6.6,3.9l11.6-3c1.7-0.5,2.8-2.2,2.3-4l-2.2-8.4 c-0.2-0.6-0.7-0.9-1.3-0.8l-1.1,0.3c0.3,1.1-0.6,2.4-1.6,2.7l-3.2,0.8L50.4,32.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 50.7,
    y1: 37.8,
    x2: 52.8,
    y2: 37.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M30.9,39.5c-6,0-10.9,2.9-10.9,6.5v16.3c0,3.6,4.9,6.5,10.9,6.5s10.9-2.9,10.9-6.5V46 C41.7,42.4,36.9,39.5,30.9,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.7,56.9c0,3.6-4.9,6.5-10.9,6.5S20,60.5,20,56.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.7,51.5c0,3.6-4.9,6.5-10.9,6.5S20,55.1,20,51.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.7,46c0,3.6-4.9,6.5-10.9,6.5S20,49.6,20,46"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9678 -0.2516 0.2516 0.9678 -2.2111 11.1666)",
    className: "st0",
    cx: 42.6,
    cy: 14.2,
    rx: 4.3,
    ry: 4.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9678 -0.2516 0.2516 0.9678 -3.9233 8.8337)",
    className: "st0",
    cx: 32.6,
    cy: 19.8,
    rx: 4.3,
    ry: 4.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsBalance);
export default __webpack_public_path__ + "static/media/points_balance.c953531b39e108b9f35c9f8c785efaa6.svg";
export { ForwardRef as ReactComponent };